module.exports = __webpack_public_path__ + "static/media/typewriter.35f8ceab.svg";